/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAchievements.vue?vue&type=template&id=acb86e36&scoped=true"
import script from "./popAchievements.vue?vue&type=script&lang=js"
export * from "./popAchievements.vue?vue&type=script&lang=js"
import style0 from "./popAchievements.vue?vue&type=style&index=0&id=acb86e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb86e36",
  null
  
)

export default component.exports